import React from "react"
import { PageProps } from "gatsby"
import { useIntl } from "gatsby-plugin-intl"
import * as styles from "./b2-connect.module.scss"

import SEO from "../../../components/seo"
import ProjectLayout from "../../../templates/project-page/ProjectLayout"
import ProjectGrid from "../../../components/UI/ProjectGrid"
import Image from "../../../components/UI/Image"


const B2Connect: React.FC<PageProps> = ({ location }) => {
	const intl = useIntl()

	const keyFutures = [
		{ title: "Internet access via Wi-Fi at reduced rates.", text: "Connection to the network was made possible through a sharings system provided by B2 Connect. Users can purchase traffic packages directly from the app." },
		{ title: "Online store with essential goods.", text: "Users can store within the app, avoiding overpayments and trips to stores." },
		{ title: "Payment system integration.", text: "Secure and easy payment via card or mobile wallets." },
		{ title: "Digital Insurance.", text: "The ability to enroll and get basic insurance products online." },
		{ title: "News and Information.", text: "A section with up-to-date news and useful resources for migrant workers." },
		{ title: "Emirates ID Upload and Verification.", text: "Users can upload documents directly into the app for faster identification." },
	]

	return (
		<ProjectLayout
			title={`B2Connect: \nA Mobile Application For \na Wi-Fi Provider in UAE `}
			date="2020-2021"
			desktopImage="/images/projects/b2-connect/b2-title.png"
			mobileImage="/images/projects/b2-connect/m-b2-title.png"
			description="Migrant workers in the Gulf often face limited access to the internet, digital services and basic amenities. To change this situation, B2 Connect launched a project to create a mobile app - a digital platform to support and improve the daily lives of residents of worker settlements. Our task is to translate this idea into a convenient and functional product."
			client="B2 Connect (UAE)"
			expretise={`Full-cycle development \nDesign support \nAnalytics`}
			projectImage="/images/projects/b2-connect/title.png"
			border
			back="white"
		>
			<SEO
				language={intl.locale}
				description={intl.formatMessage({ id: "projects-new.list.b2.description" })}
				title={intl.formatMessage({ id: "projects-new.list.b2.metatitle" })}
				pathname={location.pathname}
			/>
			{/* Дополнительный контент */}
			<section className={styles.objective}>
				<h2>Objective</h2>
				<p className={styles.subtitle}>{`Develop an intuitive mobile application for residents \nof working hostels, which will allow them to:`}</p>
				<ProjectGrid
					number
					rows
					listItems={[
						{ title: "Access the internet at affordable rates (alternative to expensive operator services);" },
						{ title: "Make purchases in the online store;" },
						{ title: "Pay for services online;" },
						{ title: "Get insurance;" },
						{ title: "Download and verify your Emirates ID (EID)." },
					]}
				/>
			</section>
			<section className={styles.solution}>
				<h2>Solution</h2>

				<div className={styles.solutionSubtitle}>
					<p>
						We worked with the B2 Connect team to create a single mobile app that became a digital hub for working communities.
					</p>
				</div>
				<div className={styles.solutionImg}><Image src="/images/projects/b2-connect/solution-1.png" alt="UI kit \ User flow" fill /></div>
				<h3>Key features:</h3>
				<ul className={styles.solutionList}>
					{
						keyFutures.slice(0, 3).map((item, index) => (
							<li className={styles.solutionItem} key={index}>
								<p className={styles.solutionListTitle}>{item.title}</p>
								<p>{item.text}</p>
							</li>
						))
					}
				</ul>
				<div className={styles.solutionImgLarge}><Image src="/images/projects/b2-connect/solution-2.png" alt="Audit: busuness card" fill /></div>
				<ul className={`${styles.solutionList} ${styles.solutionListTwo}`}>
					{
						keyFutures.slice(3, 7).map((item, index) => (
							<li className={styles.solutionItem} key={index}>
								<p className={styles.solutionListTitle}>{item.title}</p>
								<p>{item.text}</p>
							</li>
						))
					}
				</ul>
				<div className={styles.solutionImgLarge}><Image src="/images/projects/b2-connect/solution-3.png" alt="B2 - connect - interface" fill /></div>
			</section>
			<section className={styles.result}>
				<h2>Result</h2>
				<div className={styles.resultSubtitle}>
					<p>B2 Connect has become a shining example of how digital solutions can transform the lives of entire communities.</p>
				</div>
				<ProjectGrid
					bg="pink"
					listItems={[
						{ percent: "+10K", title: "active users in the first few months of launch." },
						{ title: "Significant reduction in internet connection costs for end users." },
						{ title: "Improved access to basic services and goods, which directly affects residents'quality of life." },
					]}
				/>
			</section>
		</ProjectLayout>

	)
}

export default B2Connect;
